import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Params, RouterLink } from '@angular/router';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { StoryblokCdnPipe } from '../../../storyblok/pipes/storyblok-cdn.pipe';

@Component({
  selector: 'app-link-list-item',
  templateUrl: './link-list-item.component.html',
  styleUrls: ['./link-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouterLink, SvgComponent, StoryblokCdnPipe],
})
export class LinkListItemComponent {
  public sanitization = inject(DomSanitizer);
  @Input() image: string;
  @Input() customIcon: string;
  @Input() externalLink: string;
  @Input() link: string | string[];
  @Input() fragment: string;
  @Input() query: Params;
  @Input() title: string;
  @Input() description: string;
  @Input() imageStyle: 'plain' | 'round';
  @Input() size: 'normal' | 'small' | 'tiny' = 'normal';
}
